<template>
  <div class="salesman-form-jobNumber" v-loading="loading">
    <Form ref="form" :model="formData" :label-width="95" class="page-form" :show-message="false">
      <FormItem label="工号类型" class="full" :label-width="65" v-if="$units.superviseShowVal()">
        <RadioGroup v-model="type" @on-change="radioChange">
          <Radio label="1">保险公司</Radio>
          <Radio label="2">合作通道</Radio>
        </RadioGroup>
        <div class="btn-box">
          <Button class="save-btn" type="warning" @click="add">新增</Button>
          <Button class="save-btn" type="primary" @click="importData" ghost>批量导入</Button>
          <Button class="save-btn" type="primary" @click="daochu" ghost>导出</Button>
        </div>
      </FormItem>
      <div class="btn-box" v-else>
        <Button class="save-btn" type="warning" @click="add">新增</Button>
      </div>
      <no-data v-if="showNoData"></no-data>
      <div class="table-box2" v-else>
        <div class="tr">
          <div class="td">{{type==1?'保险公司':'合作通道'}}</div>
          <div class="td">工号</div>
          <div class="td">操作</div>
        </div>
        <div class="tr" v-for="(item,i) in formData.userStaffs" :key="i" v-if="formData.type==item.staffType">
          <div class="td">
            <FormItem class="full" :label-width="0" :prop="`userStaffs.${i}.insuranceId`" :rules="$units.formRule.required('请选择')">
              <Cascader v-if="formData.type==1" :data="companyData" v-model="item.insuranceId2" @on-change="cascaderChange(arguments[1],item)" change-on-select clearable filterable></Cascader>
              <Cascader v-else :data="channelData" v-model="item.insuranceId2" @on-change="cascaderChange(arguments[1],item)" change-on-select clearable filterable></Cascader>
            </FormItem>
          </div>
          <div class="td">
            <FormItem class="full" :label-width="0" :prop="`userStaffs.${i}.staffNo`" :rules="$units.formRule.required('请输入')">
              <Input v-model.trim="item.staffNo" placeholder="请输入"/>
            </FormItem>
          </div>
          <div class="td">
            <div class="table-btn" @click="remove(i)">删除</div>
          </div>
        </div>
      </div>
    </Form>

    <!-- 导入 -->
    <importTool ref="importTool" @success="setData()"></importTool>
  </div>
</template>

<script>
import importTool from '@/components/commons/importTool/index2'
export default {
  components: {importTool},
  props: {},
  data() {
    return {
      loading:false,
      type:"1",
      formData:{
        type:"1",
        userStaffs:[],
      },
      companyData:[],//保司 树形数据
      companyList:[],//保司 list数据

      channelData:[],//合作渠道 树形数据
      channelList:[],//合作渠道 list数据
      indoorStaffId:"",
    };
  },
  computed: {
    showNoData(){
      const arr = this.formData.userStaffs.filter(item=>{
        return item.staffType == this.type
      })
      if(arr&&arr.length){
        return false
      }else{
        return true
      }
    }
  },
  mounted() {
    this.indoorStaffId = this.$route.query.indoorStaffId;
  },
  methods: {
    // 导出
    daochu(){
      this.loading = true;
      this.$http({
        url: "/buz/userStaff/export",
        type: "POST",
        responseType: "blob",
        data: {
          indoorStaffId:this.indoorStaffId,
        }
      }).then((res) => {
        this.loading = false;
        this.$units.daochu(res);
      }).catch((e) => {
        this.loading = false;
      });    
    },
    // 导入
    importData(){
      const dic = JSON.parse(localStorage.dic)['USER_STAFF_EXPORT']
      const key = Object.getOwnPropertyNames(dic)[0];
      this.$refs.importTool.open({
        params:{},
        uploadParams:{
          indoorStaffId:this.indoorStaffId,
        },
        template:key,
        templateName:dic[key],
        uploadUrl:"/buz/userStaff/batch/upload",
        errorUrl:"/buz/userStaff/exportError",
      })
    },
    save(){
      const formData = JSON.parse(JSON.stringify(this.formData));
      formData.userStaffs.find(item=>{
        if(!item.staffNo || !item.insuranceId) {
          this.type = item.staffType;
          this.formData.type = item.staffType;
          return true;
        }
      })
      formData.indoorStaffId = this.indoorStaffId;

      return new Promise((resolve, reject)=>{
        this.$refs.form.validate().then(isok=>{
          if(!isok){
            reject({page:'jobNumber',showMsg:true})
            return;
          }
          this.$http({
            type: "POST",
            url: "/buz/userStaff/batch/edit",
            data: formData
          }).then(res => {
            resolve();
          }).catch(res => {
            reject({page:'jobNumber'})
          });
        })
      })
    },
    setData(){
      this.getList();
    },
    // 获取列表数据
    getList(){
      if(!this.indoorStaffId){//新增不执行
        return;
      }
      this.loading = true;
      this.$http({
        url: '/buz/userStaff/read/list',
        type: 'post',
        data: {
          indoorStaffId:this.indoorStaffId,
        },
      }).then((res) => {
        this.loading = false;
        if(res.data&&res.data.length){
          this.formData.userStaffs = res.data;
        }
        this.getChannel();
      }).catch(()=>{
        this.loading = false;
      })
    },
    // 获取合作渠道数据
    getChannel(){
      this.channelData = [];
      this.channelList = [];

      this.companyData = [];
      this.companyList = [];
      this.$http({
        url: this.type==1?'/buz/insuranceCompany/read/tree':'/buz/insuranceChannel/read/tree',
        type: 'POST',
        data:{
          indoorStaffId:this.indoorStaffId
        }
      }).then((res) => {
        if(this.type==2) {
          res.data.forEach(item=>{
            if(item.sonInsurances){
              item.children = item.sonInsurances;
              item.children.forEach(item2=>{
                item2.label = item2.name;
                item2.value = item2.id;
                this.channelList.push(item2)
              })
            }
            item.label = item.name;
            item.value = item.id;
            this.channelList.push(item)
          })
          this.channelData = res.data;
          this.setChannelData();
        }else{
          res.data.forEach(item=>{
            if(item.sonCompanys){
              item.children = item.sonCompanys;
              item.children.forEach(item2=>{
                item2.label = item2.name;
                item2.value = item2.id;
                this.companyList.push(item2)
              })
            }
            item.label = item.name;
            item.value = item.id;
            this.companyList.push(item)
          })
          this.companyData = res.data;
          this.setCompanyData();
        }
      })
    },
    // 设置渠道类型数据
    setChannelData(){
      this.formData.userStaffs.forEach(item=>{
        if(item.staffType==2) {
          const data = this.channelList.find(bean=>{
            return bean.id==item.insuranceId
          })
          if(data){
            if(data.parentId){
              this.$set(item,"insuranceId2",[data.parentId,data.id])
            }else{
              this.$set(item,"insuranceId2",[data.id])
            }
          }
        }
      })
    },
    // 设置保司类型数据
    setCompanyData() {
      this.formData.userStaffs.forEach(item=>{
        if(item.staffType==1) {
          const data = this.companyList.find(bean=>{
            return bean.id==item.insuranceId
          })
          if(data){
            if(data.parentId){
              this.$set(item,"insuranceId2",[data.parentId,data.id])
            }else{
              this.$set(item,"insuranceId2",[data.id])
            }
          }
        }
      })
    },
    // 选择保司
    selectChange(id,item){
      const data = this.companyList.find(bean=>{
        return bean.companyId == id
      })
      item.insuranceName = data.companyName
    },
    // 切换工号类型
    radioChange(){
      this.$refs.form.validate().then(isok=>{
        if(isok){
          this.formData.type = this.type;
          this.getChannel();
        }else{
          this.type = this.formData.type;
          this.$notice.msg("请完善信息")
        }
      })
    },
    // 选择合作渠道
    cascaderChange(dataArr, item) {
      const data = dataArr.pop()
      console.log(data)
      this.$set(item,"insuranceId",data.id);
      this.$set(item,"insuranceName",data.name);
    },
    add(){
      this.formData.userStaffs.push({
        staffType:this.formData.type,
        indoorStaffId: this.indoorStaffId,
      });
    },
    remove(i){
      this.formData.userStaffs.splice(i,1)
    }
  },
};
</script>
<style lang="scss" scoped>
@import './jobNumber.scss';
</style>